// users.js: ユーザー情報の取得を行うAPIの実装
// GET  /user_information ユーザ情報を取得する
import Api from './api_base'

export default {
  get: () => {
    return Api.get('/user_information')
  }
}



// WEBPACK FOOTER //
// ./src/api/user_information.js